export const api_link =
  "https://api.hsforms.com/submissions/v3/integration/submit/8161231/279edd9a-61b7-478c-a025-ec328e072b05";
const local = {
  info: {
    REACT_APP_WEBSITE_URL: "https://www.xenonstack.com/",
  },
};

const dev = {
  auth: {
    REACT_APP_AUTH_URL: "https://application.xenonstack.ai",
  },
  app: {
    WORKSPACE_DOMAIN_NAME: ".xenonstack.ai",
  },
  info: {
    REACT_APP_WEBSITE_URL: "https://www.xenonstack.com/",
  },
};

const prod = {
  auth: {
    REACT_APP_AUTH_URL: "https://application.xenonstack.ai",
  },
  app: {
    WORKSPACE_DOMAIN_NAME: ".xenonstack.ai",
  },
  info: {
    REACT_APP_WEBSITE_URL: "https://www.xenonstack.com/",
  },
};

const config =
  process.env.REACT_APP_STAGE === "production"
    ? prod
    : process.env.REACT_APP_STAGE === "development"
    ? dev
    : 
      local;
// eslint-disable-next-line
export default {
  ...config,
};

console.log(config,"stage")
console.log(process.env.REACT_APP_STAGE,"REACT_APP_STAGE")
